import {applyMiddleware, compose, createStore} from 'redux'
import createSagaMiddleware from 'redux-saga'
//import rootReducer from './rootReducer'
import rootSaga from './sagas'
import cafe from './cafe/reducer'

export default function configureStore(initialState) {
    const sagaMiddleware = createSagaMiddleware();
    const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
    const store = createStore(
        cafe,
        initialState,
        composeEnhancers(
            applyMiddleware(
                sagaMiddleware
                // ,createLogger()
            ))
    );
    sagaMiddleware.run(rootSaga);
    return store;
}